import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CustomScrollbars from './CustomScrollbars';
import TaskItem from './TaskItem';

class TasksHistory extends Component {
	render () {
		return (
			<div className="list-group task-list">
				<h3 className="text-center">История задач</h3>
				<CustomScrollbars autoHeight autoHeightMin={100} autoHeightMax={370}>
					{
						this.props.list.map((item, key) =>
							<TaskItem
								key={key}
								item={item}
								loading={this.props.taskChanging && this.props.activeTaskId === item.id}
								onCommentChange={this.props.updateTask}
								onMoveTaskToDone={this.props.updateTask}
								loadTasksFinished={this.props.loadTasksFinished}
							/>
						)
					}
				</CustomScrollbars>
			</div>
		);
	}
}

TasksHistory.propTypes = {
	list: PropTypes.array,
	taskChanging: PropTypes.bool,
	activeTaskId: PropTypes.number,
	updateTask: PropTypes.func.isRequired,
	loadTasksFinished: PropTypes.func.isRequired
}

export default TasksHistory;



// WEBPACK FOOTER //
// ./components/TasksHistory.js